module.exports = __webpack_public_path__ + "img/lu.a3a2e106.svg";